import constants from "./constants";

export const helper = {
    formatResult: (result, localization) => {
        const boards = result.boards ? result.boards : { results: [], resultCount: 0 };
        const decor = result.decor ? result.decor : { results: [], resultCount: 0 };
        const structure = result.structure ? result.structure : { results: [], resultCount: 0 };
        const reference = result.reference ? result.reference : { results: [], resultCount: 0 };
        const page = result.page ? result.page : { results: [], resultCount: 0 };
        const downloads = result.downloads ? result.downloads : { results: [], resultCount: 0 };

        return {
            boards: {
                sectionHeadline: localization.categories.boards,
                type: constants.resultType.tile,
                kind: constants.resultKind.boards,
                results: boards.docs,
                resultCount: boards.count
            },
            decor: {
                sectionHeadline: localization.categories.decors,
                type: constants.resultType.tile,
                kind: constants.resultKind.decor,
                results: decor.docs,
                resultCount: decor.count
            },
            structure: {
                sectionHeadline: localization.categories.structures,
                type: constants.resultType.tile,
                kind: constants.resultKind.structure,
                results: structure.docs,
                resultCount: structure.count
            },
            reference: {
                sectionHeadline: localization.categories.references,
                type: constants.resultType.tile,
                kind: constants.resultKind.reference,
                results: reference.docs,
                resultCount: reference.count
            },
            page: {
                sectionHeadline: localization.categories.pages,
                type: constants.resultType.text,
                kind: constants.resultKind.page,
                results: page.docs,
                resultCount: page.count
            },
            downloads: {
                sectionHeadline: localization.categories.downloads,
                type: constants.resultType.downloads,
                kind: constants.resultKind.downloads,
                results: downloads.docs,
                resultCount: downloads.count
            },
        }
    },
    formatResultAsArray: object => {
        const keys = Object.keys(object);
        const array = [];
        keys.forEach(key => {
            array.push(object[key]);
        });
        return array;
    },
    mergeResults: (results, newResults) => {
        const resultKeys = Object.keys(results);
        const newResultKeys = Object.keys(newResults);

        resultKeys.forEach(categoryKey => {
            newResultKeys.forEach(newCategoryKey => {
                if (categoryKey === newCategoryKey) {
                    results[categoryKey].results = results[categoryKey].results.concat(newResults[newCategoryKey].results)
                }
            })
        });

        return results
    },
    convertKind: value => {
        const keys = Object.keys(constants.resultKind);
        let returnKey;
        keys.forEach(key => {
            if (constants.resultKind[key] === value) {
                returnKey = key
            }
        });

        if (returnKey) {
            return returnKey
        } else {
            return new Error("Key not found");
        }


    },
    keyboard: {
        isChar: (e) => {
            const oneKey = new RegExp("^.{1}$");
            return oneKey.test(e.key);
        },
        isDelete: (e) => {
            return e.key === 'Delete' || e.key === 'Backspace';
        }
    }
};
